import React from "react";
import { Link, useLocation } from "react-router-dom";
import DynamicYear from "../ui/DynamicYear";

const Footer = () => {
  const location = useLocation();

  // Check if we are on home page
  const isHome = location.pathname === "/";
  // Pages where footer should be shown even for anonymous users
  const anonymousFooterPaths = [
    "/", // Home
    "/terms-of-service",
    "/privacy-policy",
    "/cookies-policy",
    "/accessibility",
    "/impartiality",
    "/about",
    "/contact",
    "/features"
  ];
  const shouldShowFooter = anonymousFooterPaths.includes(location.pathname);

  const hrDisplayPages = [
     "/terms-of-service",
    "/privacy-policy",
    "/cookies-policy",
    "/accessibility",
    "/impartiality"
  ]
  const shouldShowhr = hrDisplayPages.includes(location.pathname)
  return (
   <>
   {shouldShowFooter ? <footer
  className={`footer ${
    isHome
      ? "absolute bottom-0 w-full text-white flex-shrink-0 h-[60px] flex flex-col"
      : "w-full text-black flex flex-col pt-4 pb-4 "
  }`}
>
  {/* HR at top */}
  {/* <hr className="w-full border-gray-500 pb-4" /> */}
  {isHome || shouldShowhr ? <hr className="w-full border-gray-500 pb-4" /> : null}


  <div className="max-w-7xl mx-auto px-4 flex justify-between items-center w-full text-sm">
    {/* Brand */}
    {/* <div className="flex items-center space-x-2">
      <AcademicCapIcon
  className={`h-5 w-5 ${isHome ? "text-white hover:text-gray-300" : "text-blue-500 hover:text-blue-700"}`}
/>

      <span className="font-semibold">Unify Academy</span>
    </div> */}

    {/* Links */}
    <div className="hidden sm:flex items-center space-x-6">
      <Link to="/about" className="text-black-400">About</Link>
      <Link to="/contact" className="text-black-400">Contact</Link>
      <Link to="/features" className="text-black-400">Features</Link>
    </div>

    {/* Copyright */}
    <div className="text-black-400 text-xs">
      <DynamicYear format="copyright" /> Unify Digital. All rights reserved.
    </div>

    {/* Legal Links */}
    <div className="hidden sm:flex items-center space-x-6">
      <Link to="/terms-of-service" className="text-black-400 ">Terms</Link>
      
      <Link to="/cookies-policy" className="text-black-400 ">Cookies</Link>
      
      <Link to="/privacy-policy" className="text-black-400 ">Privacy</Link>
      
      <Link to="/accessibility" className="text-black-400 ">Accessibility</Link>
     
      <Link to="/impartiality" className="text-black-400 ">Impartiality</Link>
    </div>
  </div>
</footer> : "" }
   

   
   </>
   
  );
};

export default Footer;

